<app-sidenav-filters
  [isOpen]="isSidenavOpen"
  (toggleSidenav)="toggleSidenav($event)"
  (torn)="changeTorn($event)"
  (unknown)="changeUnknown($event)"
  (site)="siteRequest($event)"
  (filter)="updateFilter($event)"
  (colorStatus)="changeColorStatus($event)"
  (devices)="changeDevices($event)"
  (lastSites)="changeLastSites($event)"
  (incidents)="changeIncidents($event)"
  (containers)="changeContainers($event)"
  (statusDays)="changeStatusDays($event)"
  (addIncidentDevices)="changeIncidentDevices($event)"
  (confidenceRadius)="changeConfidenceRadius($event)"
  (devicesTypes)="changeDevicesTypes($event)"
  (containerCategory)="changeContainerCategory($event)"
  [filterTorn]="filterTorn"
  [filterUnknown]="filterUnknown"
  [filterDevices]="filterDevices"
  [filterLastSites]="filterLastSites"
  [filterIncidents]="filterIncidents"
  [filterContainers]="filterContainers"
  [filterStatusDays]="filterStatusDays"
  [filterConfidenceRadius]="filterConfidenceRadius"
  [filterDevicesTypes]="filterDevicesTypes"
  [filterContainerCategory]="filterContainerCategory"
  [filterStatus]="statusList"
></app-sidenav-filters>

<div class="list-wrapper" [ngClass]="{ hidden: showMap }">
  @if (infoCurrentState && showInfo) {
    <app-detail
      [(display)]="showInfo"
      [(currentState)]="infoCurrentState"
      [hidden]="!showInfo"
      (displayChange)="reloadList($event)"
      (navigate)="navChange($event)"
    ></app-detail>
  }

  @if (!infoCurrentState && !showInfo) {
    <app-header-list
      (showList)="reloadList()"
      (toggleFilters)="toggleSidenav($event)"
      [isSidenavOpen]="isSidenavOpen"
      (torn)="changeTorn($event)"
      (unknown)="changeUnknown($event)"
      (site)="siteRequest($event)"
      (filter)="updateFilter($event)"
      (colorStatus)="changeColorStatus($event)"
      (devices)="changeDevices($event)"
      (lastSites)="changeLastSites($event)"
      (incidents)="changeIncidents($event)"
      (containers)="changeContainers($event)"
      (statusDays)="changeStatusDays($event)"
      (addIncidentDevices)="changeIncidentDevices($event)"
      (confidenceRadius)="changeConfidenceRadius($event)"
      (devicesTypes)="changeDevicesTypes($event)"
      [loadingProgress]="loadingProgress"
      [listSites]="listSites"
      [exportType]="exportType"
      [exportData]="exportData"
      [listIncidentDevices]="listIncidentDevices"
      [isEmptyIncidentDevice]="isEmptyIncidentDevice"
      [filterTorn]="filterTorn"
      [filterUnknown]="filterUnknown"
      [filterSite]="filterSiteCode"
      [filterDevices]="filterDevices"
      [filterLastSites]="filterLastSites"
      [filterIncidents]="filterIncidents"
      [filterContainers]="filterContainers"
      [filterStatusDays]="filterStatusDays"
      [filterConfidenceRadius]="filterConfidenceRadius"
      [filterDevicesTypes]="filterDevicesTypes"
      [filterContainerCategory]="filterContainerCategory"
    >
    </app-header-list>
  }
  @if (!showInfo) {
    <div class="list-content">
      @if (!sortedCurrentStateList || sortedCurrentStateList.length > 0) {
        <div class="array-wrapper">
          <app-state-displayer-column-names
            (checkboxUpdate)="updateAllIncidentDevices($event)"
            type="List"
            [hasCheckbox]="hasHeaderCheckbox()"
          ></app-state-displayer-column-names>
          <div
            class="data"
            [infiniteScroll]="loadMore"
            [scrollRatio]="0.4"
            [initScrollThreshold]="50"
          >
            @if (!sortedCurrentStateList) {
              <div>
                @for (_ of [].constructor(20); track $index) {
                  <div class="skeleton-placeholders">
                    <app-state-displayer-skeleton-line
                      type="List"
                    ></app-state-displayer-skeleton-line>
                  </div>
                }
              </div>
            }
            @for (
              currentState of sortedCurrentStateList;
              track currentState.deviceId;
              let i = $index
            ) {
              <div (click)="showInfoContainer($event, currentState)">
                @if (i) {
                  <div class="information-divider"></div>
                }
                <app-state-displayer
                  (openCategory)="onOpenCategory($event)"
                  (handleDevice)="handleDeviceIncident($event)"
                  [(currentState)]="sortedCurrentStateList[i]"
                  [isChecked]="allChecked"
                  [listDisplay]="true"
                  (navigate)="onChangeTab($event)"
                ></app-state-displayer>
              </div>
            }
          </div>
        </div>
        <div class="list-info">
          @if (
            sortedCurrentStateList?.length > 0 &&
            totalFiteredCurrentStates !== undefined
          ) {
            <p class="total-devices">
              {{
                "list.totalDevices"
                  | translate
                    : {
                        currentDeviceNumber: sortedCurrentStateList.length,
                        totalDeviceNumber: totalFiteredCurrentStates
                      }
              }}
            </p>
          }
          <div class="download-button">
            <app-export-excel
              class="list-tfoot-export"
              [type]="exportType"
              [data]="exportData"
              [totalListCurrentStates]="totalFiteredCurrentStates"
              [disabled]="!sortedCurrentStateList?.length"
            ></app-export-excel>
          </div>
        </div>
      }
      @if (sortedCurrentStateList && !sortedCurrentStateList.length) {
        <p>{{ "list.noContainers" | translate }}</p>
      }
    </div>
  }
  @if (showCreateIncident && !showInfo) {
    <app-incident-sidenav
      (closed)="closeIncidentCreation()"
      (incidentCreated)="addIncidentList($event)"
      [devices]="listIncidentDevices"
    ></app-incident-sidenav>
  }
</div>
